module.exports = __webpack_public_path__ + "img/ARCS_ph.9ccdbb83.png";